import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AnonymousEditor } from '@/components/AnonymousEditor';
import { SEO } from '@/components/SEO';

export default function TryItOut() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  if (user) {
    return null;
  }

  return (
    <>
      <SEO
        title="Instant Free Invoice Generator & Maker | QuickFreeInvoice"
        description="Try our free online invoice generator playground without logging in. Design custom templates, calculate taxes, and download PDF invoices instantly."
        keywords="instant invoice builder, free online invoice maker no login, create invoice without account, quick PDF invoice generator, free invoice template playground, quick online quotation maker"
      />
      <AnonymousEditor hideNoticeHeader={false} />
    </>
  );
}
